import { apiGet, apiPut } from '../client';
import {
  BusinessMeResponseSchema,
  BusinessPermissionsResponseSchema,
  type AccessProfile,
  type BusinessMeResponse,
  type BusinessPermissionsResponse,
  type PermissionKey,
} from '../schemas';

export const PERMISSIONS_QUERY_KEY = ['business-permissions'];
export const ME_QUERY_KEY = ['business-me'];

/** What each profile may use in this location. Owner-only. */
export function getPermissions(): Promise<BusinessPermissionsResponse> {
  return apiGet('/v1/business/permissions', BusinessPermissionsResponseSchema);
}

/** Replaces one profile's whole list; the API refuses the write without an Idempotency-Key. */
export function savePermissions(
  profile: AccessProfile,
  permissions: readonly PermissionKey[],
  idempotencyKey: string,
): Promise<BusinessPermissionsResponse> {
  return apiPut(
    `/v1/business/permissions/${encodeURIComponent(profile)}`,
    BusinessPermissionsResponseSchema,
    { permissions },
    idempotencyKey,
  );
}

/** Who is signed in and what they may use right now; any business session. */
export function getMe(): Promise<BusinessMeResponse> {
  return apiGet('/v1/business/me', BusinessMeResponseSchema);
}
